var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 793,
    height: 690,
    viewBox: "0 0 793 690",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4029 124.133C137.423 4.18342 225.707 -44.7115 267.454 49.392C309.202 143.496 425.476 -54.5319 507.513 21.4483C589.551 97.4286 1023.62 580.171 631.028 538.423C238.432 496.676 437.633 728.449 241.448 649.676C45.2634 570.902 139.794 771.485 -24.6168 649.676C-189.028 527.866 -24.6169 244.082 56.4029 124.133Z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlob);
export default __webpack_public_path__ + "static/media/heroBlob.8bcad0c21cbfa907707f1d74e837c162.svg";
export { ForwardRef as ReactComponent };